import { ensureHHazardAndPhysical } from './ensureHHazardAndPhysical.js';
import { ensureSmiles } from './ensureSmiles.js';
import { normalizeQuantities } from './normalizeQuantities.js';

export async function prepareReagents(reagents, options = {}) {
  reagents = JSON.parse(JSON.stringify(reagents));
  for (const reagent of reagents) {
    normalizeQuantities(reagent, options);
    ensureSmiles(reagent);
    await ensureHHazardAndPhysical(reagent);
    reagent.safety = {};
  }

  return reagents;
}
